/**
 * Reverses a string.
 */
export default function reverse(s: string): string {
  return [...s].reverse().join('');
}
